"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.virtualPageEventDispatch = void 0;
var VirtualPageEvent = _interopRequireWildcard(require("@ori-events/virtual-page"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const pageTitle = 'checkout-registration';
const virtualPagePathNameMap = new Map([['PersonalInfo', 'registration-personal-info'], ['ContactVerification', 'registration-contact-verification']]);
const getVirtualPagePathName = virtualPage => {
  if (virtualPagePathNameMap.has(virtualPage)) {
    return virtualPagePathNameMap.get(virtualPage);
  }
  return 'unknown-step';
};
const getVirtualPageURL = (urlBase, virtualPage) => `${urlBase}/${getVirtualPagePathName(virtualPage)}`;
const getPageURL = step => {
  const urlBase = window.location.origin + window.location.pathname;
  if (!step) {
    return urlBase + window.location.search;
  }
  return getVirtualPageURL(urlBase.replace(/\/+$/, ''), step);
};
const virtualPageEventDispatch = (currentStep, previousStep) => {
  const virtualPageEventData = {
    virtualPageTitle: pageTitle,
    virtualPageURL: getPageURL(currentStep),
    previousPageURL: getPageURL(previousStep)
  };
  const event = new CustomEvent(VirtualPageEvent.Name, {
    detail: virtualPageEventData
  });
  window.dispatchEvent(event);
};
exports.virtualPageEventDispatch = virtualPageEventDispatch;
